import React from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import SeoLayout from '../../layout/seolayout/SeoLayout';

const SeoThankYou = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const email = searchParams.get('email');

  return (
    <SeoLayout>
      <Helmet>
        <title>Digital Marketing Agency in India</title>
        <meta name="description" content="Custom Top website development company in India, G-Rank provides world-class, experienced developers that work to the highest standards & ramp up quickly" />
      </Helmet>
      
      <div className="container-fluid thankyou-div">
        <h1 className="text-anime">
          Thank You!! <br />
          {email ? <p>{email}</p> : <p>Email data not found.</p>}
        </h1>
        <h2>Thank you for your interest! Our representative will call you back shortly!!</h2>
        <a href="/" className="btn btn-primary">Back to Home</a>
      </div>
    </SeoLayout>
  );
};

export default SeoThankYou;
